import { useState, useEffect } from 'react';

/**
 * Custom hook for managing theme (light/dark mode)
 */
export const useTheme = () => {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    // Get initial theme: check localStorage first, then browser preference, default to dark
    const getInitialTheme = () => {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme) {
        return savedTheme;
      }
      // Check browser preference
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: light)').matches) {
        return 'light';
      }
      return 'dark';
    };
    
    const initialTheme = getInitialTheme();
    setTheme(initialTheme);
    document.documentElement.className = initialTheme === 'light' ? 'light' : '';
  }, []);

  const toggle = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.className = newTheme === 'light' ? 'light' : '';
  };

  return [theme, toggle];
};

